/* 6FT Club — site-wide behaviour.
   Interactions follow the design canvas; every cart action goes through
   Shopify's Ajax Cart API and re-renders the cart drawer section, so the
   drawer always shows the real cart. Each feature is guarded by the
   elements it needs, so this file is safe on every template. */
(function () {
  'use strict';

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Something went wrong');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------------------------------------------------------------------
     Toast for errors (e.g. "only 3 left") so failures are never silent
  --------------------------------------------------------------------- */
  function toast(message) {
    var el = qs('#sx-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sx-toast';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 4200);
  }

  /* ---------------------------------------------------------------------
     Overlay helper: open/close with focus return + scroll lock
  --------------------------------------------------------------------- */
  var openStack = [];
  function openOverlay(el, focusEl) {
    if (!el || el.classList.contains('open')) return;
    el._returnFocus = document.activeElement;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    openStack.push(el);
    document.documentElement.classList.add('sx-lock');
    if (focusEl) setTimeout(function () { focusEl.focus({ preventScroll: true }); }, 60);
  }
  function closeOverlay(el) {
    if (!el || !el.classList.contains('open')) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    openStack = openStack.filter(function (x) { return x !== el; });
    if (!openStack.length) document.documentElement.classList.remove('sx-lock');
    if (el._returnFocus && document.contains(el._returnFocus)) el._returnFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openStack.length) return;
    var top = openStack[openStack.length - 1];
    if (top.id === 'mobile-nav-overlay') MobileNav.close();
    else closeOverlay(top);
  });

  /* ---------------------------------------------------------------------
     Mobile hamburger nav
  --------------------------------------------------------------------- */
  var MobileNav = {
    open: function () {
      var o = qs('#mobile-nav-overlay'); var t = qs('#mobile-nav-toggle');
      if (t) t.setAttribute('aria-expanded', 'true');
      openOverlay(o, qs('#mobile-nav-close'));
    },
    close: function () {
      var t = qs('#mobile-nav-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
      closeOverlay(qs('#mobile-nav-overlay'));
    }
  };

  /* ---------------------------------------------------------------------
     Cart
  --------------------------------------------------------------------- */
  var Cart = {
    root: function () { return qs('#cart-drawer-root'); },
    modal: function () { return qs('#cart-modal'); },

    render: function (sections) {
      if (!sections) return;
      var wasOpen = this.modal() && this.modal().classList.contains('open');
      var focusedId = document.activeElement && document.activeElement.id;
      if (sections['cart-drawer'] && this.root()) {
        this.root().innerHTML = sections['cart-drawer'];
        if (wasOpen) {
          var m = this.modal();
          m.classList.add('open');
          m.setAttribute('aria-hidden', 'false');
          openStack = openStack.filter(function (x) { return document.contains(x); });
          openStack.push(m);
        }
        if (focusedId && document.getElementById(focusedId)) document.getElementById(focusedId).focus({ preventScroll: true });
      }
      if (sections['cart-icon-bubble']) {
        var bubble = qs('#cart-icon-bubble');
        if (bubble) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section');
          bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
        }
        var count = this.modal() ? this.modal().getAttribute('data-item-count') : null;
        var toggle = qs('#cart-toggle');
        if (toggle && count !== null) toggle.setAttribute('aria-label', 'Cart, ' + count + ' items');
      }
      document.dispatchEvent(new CustomEvent('sixft:cart-updated'));
    },

    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=' + SECTIONS.join(','))
        .then(function (r) { return r.json(); })
        .then(function (s) { self.render(s); });
    },

    addVariant: function (variantId, quantity, properties) {
      var self = this;
      var item = { id: Number(variantId), quantity: quantity || 1 };
      if (properties) item.properties = properties;
      return postJSON('/cart/add.js', { items: [item], sections: SECTIONS, sections_url: window.location.pathname })
        .then(function (res) { self.render(res.sections); return res; })
        .catch(function (err) { toast(err.message); throw err; });
    },

    change: function (key, quantity) {
      var self = this;
      var line = qs('.cart-line-item[data-key="' + CSS.escape(key) + '"]');
      if (line) line.classList.add('is-loading');
      return postJSON('/cart/change.js', { id: key, quantity: quantity, sections: SECTIONS, sections_url: window.location.pathname })
        .then(function (res) { self.render(res.sections); return res; })
        .catch(function (err) { if (line) line.classList.remove('is-loading'); toast(err.message); throw err; });
    },

    swapVariant: function (key, newVariantId, quantity) {
      var self = this;
      var line = qs('.cart-line-item[data-key="' + CSS.escape(key) + '"]');
      if (line) line.classList.add('is-loading');
      return postJSON('/cart/change.js', { id: key, quantity: 0 })
        .then(function () { return self.addVariant(newVariantId, quantity); })
        .catch(function () { return self.refresh(); });
    },

    updateDiscount: function (code) {
      var self = this;
      return postJSON('/cart/update.js', { discount: code, sections: SECTIONS, sections_url: window.location.pathname })
        .then(function (res) { self.render(res.sections); return res; });
    },

    open: function () {
      openOverlay(this.modal(), qs('#cart-close'));
      var gorgias = document.getElementById('gorgias-chat-container');
      if (gorgias) gorgias.style.display = 'none';
    },
    close: function () {
      closeOverlay(this.modal());
      var gorgias = document.getElementById('gorgias-chat-container');
      if (gorgias) gorgias.style.display = '';
    }
  };
  window.SixFtCart = {
    addVariant: Cart.addVariant.bind(Cart),
    open: Cart.open.bind(Cart),
    close: Cart.close.bind(Cart),
    refresh: Cart.refresh.bind(Cart),
    change: Cart.change.bind(Cart)
  };


  /* US state from the first three ZIP digits (USPS prefix ranges), so the
     estimator only needs a ZIP as in the design. */
  var ZIP3 = [[5,5,'NY'],[6,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[90,99,'AE'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[569,569,'DC'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,715,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,961,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function stateFromZip(zip) {
    var n = parseInt(String(zip).slice(0, 3), 10);
    for (var i = 0; i < ZIP3.length; i++) if (n >= ZIP3[i][0] && n <= ZIP3[i][1]) return ZIP3[i][2];
    return '';
  }

  /* Shipping estimator — Shopify's real rate calculation */
  function estimateShipping(zip, country) {
    var params = 'shipping_address%5Bzip%5D=' + encodeURIComponent(zip) + '&shipping_address%5Bcountry%5D=' + encodeURIComponent(country);
    if (country === 'United States') params += '&shipping_address%5Bprovince%5D=' + encodeURIComponent(stateFromZip(zip));
    return fetch('/cart/prepare_shipping_rates.json?' + params, { method: 'POST' })
      .then(function (r) {
        if (r.ok) return null;
        return r.json().then(function (d) {
          var msg = d && typeof d === 'object' ? Object.keys(d).map(function (k) { return k + ' ' + [].concat(d[k]).join(', '); }).join('. ') : 'Could not estimate shipping';
          throw new Error(msg);
        });
      })
      .then(function poll(_, attempt) {
        attempt = attempt || 0;
        return fetch('/cart/async_shipping_rates.json?' + params).then(function (r) { return r.json(); }).then(function (d) {
          if (d && d.shipping_rates) return d.shipping_rates;
          if (attempt > 12) throw new Error('Shipping rates are taking too long, try again');
          return new Promise(function (res) { setTimeout(res, 600); }).then(function () { return poll(null, attempt + 1); });
        });
      });
  }

  function formatRates(rates) {
    if (!rates.length) return '<div class="cart-ship-rate"><span class="cart-foot__muted">No shipping options for this address</span></div>';
    var fmtDate = function (d) { return new Date(d + 'T12:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return rates.slice(0, 3).map(function (rate) {
      var free = Number(rate.price) === 0;
      var price = free ? 'FREE' : new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(Number(rate.price));
      var eta = '';
      if (rate.delivery_range && rate.delivery_range.length === 2) {
        var a = fmtDate(rate.delivery_range[0]), b = fmtDate(rate.delivery_range[1]);
        eta = 'Estimated delivery ' + (a === b ? a : a + '–' + b);
      } else if (rate.description) {
        eta = rate.description;
      }
      return '<div class="cart-ship-rate-wrap">' +
        '<div class="cart-ship-rate"><span class="cart-foot__muted">' + escapeHTML(rate.presentment_name || rate.name) + '</span>' +
        '<span class="cart-ship-rate__price' + (free ? ' is-free' : '') + '">' + escapeHTML(price) + '</span></div>' +
        (eta ? '<div class="cart-ship-rate__eta">' + escapeHTML(eta) + '</div>' : '') +
      '</div>';
    }).join('');
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------------------------------------------------------------------
     Quick view
  --------------------------------------------------------------------- */
  var QuickView = {
    variantId: null,
    open: function (handle) {
      var modal = qs('#qv-modal');
      if (!modal || !handle) return;
      var self = this;
      Cart.close();
      modal.classList.add('is-loading');
      openOverlay(modal, qs('#qv-close'));
      fetch('/products/' + encodeURIComponent(handle) + '?view=qv')
        .then(function (r) { if (!r.ok) throw new Error('Product unavailable'); return r.json(); })
        .then(function (p) { self.fill(p); modal.classList.remove('is-loading'); })
        .catch(function (err) { closeOverlay(modal); modal.classList.remove('is-loading'); toast(err.message); });
    },
    fill: function (p) {
      var self = this;
      var img = qs('#qv-img');
      img.src = p.image || img.src; img.alt = p.title;
      qs('#qv-badge').textContent = p.lift ? p.lift + ' lift' : '';
      qs('#qv-name').textContent = p.title;
      qs('#qv-desc').textContent = p.subtitle || '';
      qs('#qv-visit-link').href = p.url;
      var cta = qs('#qv-cta');
      var grid = qs('#qv-size-grid');
      var sizeWrap = qs('#qv-size-wrap');
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      self.showPrice(first);
      grid.innerHTML = '';
      self.variantId = null;
      qs('#qv-size-label').textContent = p.option_name && p.option_name !== 'Title' ? p.option_name.replace(/^Shoe size$/i, 'Size') : 'Size';

      if (p.has_only_default_variant) {
        sizeWrap.hidden = true;
        self.variantId = first.available ? first.id : null;
        cta.disabled = !first.available;
        cta.textContent = first.available ? 'Add to cart' : 'Sold out';
        return;
      }
      sizeWrap.hidden = false;
      cta.disabled = true;
      cta.textContent = 'Select your size';
      p.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qv-size-btn';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', 'false');
        b.textContent = v.title;
        if (!v.available) { b.disabled = true; b.setAttribute('aria-label', v.title + ', sold out'); }
        b.addEventListener('click', function () {
          qsa('.qv-size-btn', grid).forEach(function (x) { x.classList.remove('selected'); x.setAttribute('aria-checked', 'false'); });
          b.classList.add('selected'); b.setAttribute('aria-checked', 'true');
          self.variantId = v.id;
          self.showPrice(v);
          cta.disabled = false;
          cta.textContent = 'Add to cart';
        });
        grid.appendChild(b);
      });
    },
    showPrice: function (v) {
      qs('#qv-price').textContent = v.price;
      qs('#qv-orig').textContent = v.compare_at_price || '';
      qs('#qv-off').textContent = v.percent_off > 0 ? v.percent_off + '% off' : '';
    },
    add: function () {
      var cta = qs('#qv-cta');
      if (!this.variantId || cta.disabled) return;
      cta.disabled = true;
      cta.textContent = 'Adding…';
      Cart.addVariant(this.variantId, 1).then(function () {
        closeOverlay(qs('#qv-modal'));
        Cart.open();
      }).catch(function () {
        cta.disabled = false;
        cta.textContent = 'Add to cart';
      });
    }
  };
  window.SixFtQuickView = { open: QuickView.open.bind(QuickView) };

  /* ---------------------------------------------------------------------
     Fit quiz (canvas flow, real products from the section config)
  --------------------------------------------------------------------- */
  var FitQuiz = (function () {
    var cfgEl, cfg, body, fq;
    var BACK = '<button type="button" class="fq-back" data-fq-back><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M15 5 L7 12 L15 19" stroke-linecap="round" stroke-linejoin="round"></path></svg>Back</button>';
    var INSOLE_KEYS = ['original', 'next-level', 'stealth'];

    function reset() { fq = { step: 'intro', history: [], answers: {}, overrideKey: null }; render(); }
    function total() {
      if (fq.answers.type === 'insole') return 2;
      if (fq.answers.category === 'chelsea' || fq.answers.category === 'sneaker') return 3;
      if (fq.answers.type === 'shoe') return 2;
      return 3;
    }
    function answered() { var n = 0; if (fq.answers.type) n++; if (fq.answers.category || fq.answers.lift) n++; if (fq.answers.style) n++; return n; }
    function progress() { var d = ''; for (var i = 0; i < total(); i++) d += '<div class="fq-progress-dot' + (i < answered() ? ' done' : '') + '"></div>'; return '<div class="fq-progress">' + d + '</div>'; }
    function opt(answer, label, sub) { return '<button type="button" class="fq-option-btn" data-answer="' + answer + '">' + label + '<span class="fq-option-sub">' + sub + '</span></button>'; }
    function step(n, q, options) { return (fq.history.length ? BACK : '') + progress() + '<div class="fq-eyebrow">Step ' + n + '</div><div class="fq-question">' + q + '</div><div class="fq-options">' + options + '</div>'; }

    function resolveShoe() {
      var c = fq.answers.category, s = fq.answers.style;
      if (c === 'dress') return { key: 'executive-black', alts: [] };
      if (c === 'lace') return { key: 'montaro-dune', alts: [] };
      if (c === 'chelsea') return s === 'suede' ? { key: 'westbridge-suede', alts: ['blackstons'] } : { key: 'blackstons', alts: ['westbridge-suede'] };
      if (c === 'sneaker') {
        if (s === 'knit') return { key: 'ashford-knit', alts: [] };
        if (s === 'mesh') return { key: 'harlow-runner', alts: [] };
        return { key: 'camden-low', alts: ['sutton-court'] };
      }
      return { key: 'blackstons', alts: [] };
    }
    function has(key) { return cfg.results[key] && cfg.results[key].handle; }

    function result() {
      var isShoe = fq.answers.type === 'shoe';
      var key, alts;
      if (isShoe) {
        var r = resolveShoe();
        key = fq.overrideKey || r.key;
        alts = fq.overrideKey ? [r.key].concat(r.alts).filter(function (k) { return k !== key; }) : r.alts;
      } else {
        key = fq.overrideKey || fq.answers.lift;
        alts = INSOLE_KEYS.filter(function (k) { return k !== key; });
      }
      alts = alts.filter(has);
      if (!has(key)) {
        var url = isShoe ? cfg.shoesUrl : cfg.insolesUrl;
        return '<div class="fq-eyebrow">Your fit</div><div class="fq-question" style="font-size:20px;margin-bottom:18px;">We&rsquo;ll show you everything that fits that brief.</div>' +
          '<a href="' + escapeHTML(url) + '" class="btn btn-solid" style="justify-content:center;width:100%;">' + (isShoe ? 'Shop shoes' : 'Shop insoles') + '</a>' +
          '<button type="button" class="fq-retake" data-fq-retake>Retake the quiz</button>';
      }
      fq.resultKey = key; fq.resultIsShoe = isShoe;
      var p = cfg.results[key];
      var img = p.img ? '<img src="' + escapeHTML(p.img) + '" alt="' + escapeHTML(p.name) + '" width="96" height="96" loading="lazy">' : '<span>Product photo</span>';
      var price = '<span style="font-weight:700;">' + escapeHTML(p.price) + '</span>' + (p.orig ? ' <span style="text-decoration:line-through;color:var(--muted);font-size:12.5px;margin-left:4px;">' + escapeHTML(p.orig) + '</span>' : '');
      var altHTML = alts.length ? '<div class="fq-alt-row">' + alts.map(function (k) { return '<button type="button" class="fq-alt-chip" data-alt="' + k + '">Or try ' + escapeHTML(cfg.results[k].name) + '</button>'; }).join('') + '</div>' : '';
      var cta = isShoe
        ? '<button type="button" class="btn btn-solid" data-fq-shop style="justify-content:center;width:100%;border:none;font:inherit;">Shop this style</button>'
        : '<a href="' + escapeHTML(p.url) + '" class="btn btn-solid" style="justify-content:center;width:100%;text-decoration:none;">Shop insoles</a>';
      return '<div class="fq-eyebrow">Your fit</div>' +
        '<div class="fq-question" style="font-size:20px;margin-bottom:18px;">Based on your answers, we&rsquo;d start here:</div>' +
        '<div class="fq-result-card"><div class="fq-result-img' + (p.img ? '' : ' ph') + '">' + img + '</div>' +
        '<div style="flex:1;min-width:0;"><div style="font-size:10.5px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;color:var(--muted);margin-bottom:4px;">' + escapeHTML(p.badge) + '</div>' +
        '<div style="font-size:17px;font-weight:800;">' + escapeHTML(p.name) + '</div>' +
        '<div style="font-size:12.5px;color:var(--muted);margin:3px 0 8px;">' + escapeHTML(p.desc) + '</div>' +
        '<div style="font-size:13px;">' + price + '</div></div></div>' +
        altHTML + cta + '<button type="button" class="fq-retake" data-fq-retake>Retake the quiz</button>';
    }

    function render() {
      var html = '';
      if (fq.step === 'intro') {
        html = '<div class="fq-eyebrow">Find your fit</div><div class="fq-question">A couple of quick questions and we&rsquo;ll point you to the right style.</div><div class="fq-options"><button type="button" class="fq-option-btn" data-go="q1">Let&rsquo;s go<span class="fq-option-sub">Takes about 20 seconds</span></button></div>';
      } else if (fq.step === 'q1') {
        html = step(1, 'What are you shopping for?', opt('type:shoe', 'Shoes', 'Added height built into the sole') + opt('type:insole', 'Insoles', 'Slip into shoes you already own'));
      } else if (fq.step === 'q2-shoe') {
        html = step(2, 'What&rsquo;s it mostly for?', opt('category:dress', 'Office &amp; dress', 'Polished, boardroom-ready') + opt('category:chelsea', 'Chelsea boot', 'Going out, smart-casual') + opt('category:lace', 'Everyday lace-up', 'Versatile boot for daily wear') + opt('category:sneaker', 'Casual &amp; sneakers', 'Weekend, travel, everyday'));
      } else if (fq.step === 'q3-chelsea') {
        html = step(3, 'Suede or leather?', opt('style:suede', 'Suede', 'Softer texture, more casual') + opt('style:leather', 'Leather', 'Smoother finish, more formal'));
      } else if (fq.step === 'q3-sneaker') {
        html = step(3, 'Pick a vibe', opt('style:leather', 'Clean leather sneaker', 'Minimal, pairs with anything') + opt('style:knit', 'Knit, sock-like fit', 'Stretchy, breathable') + opt('style:mesh', 'Athletic mesh', 'Lightest, most flexible'));
      } else if (fq.step === 'q2-insole') {
        html = step(2, 'How much lift are you looking for?', opt('lift:original', 'Maximum — 2.4&Prime;', 'Our tallest lift') + opt('lift:next-level', 'Noticeable — 1.8&Prime;', 'Versatile, everyday height') + opt('lift:stealth', 'Subtle — 1.5&Prime;', 'Low-profile, hard to detect'));
      } else if (fq.step === 'result') {
        html = result();
      }
      body.innerHTML = html;
      var firstBtn = body.querySelector('button, a');
      if (firstBtn && qs('#fitquiz-modal').classList.contains('open')) firstBtn.focus({ preventScroll: true });
    }
    function go(s) { fq.history.push(fq.step); fq.step = s; render(); }
    function advance() {
      if (fq.step === 'q1') return go(fq.answers.type === 'shoe' ? 'q2-shoe' : 'q2-insole');
      if (fq.step === 'q2-shoe') {
        if (fq.answers.category === 'chelsea') return go('q3-chelsea');
        if (fq.answers.category === 'sneaker') return go('q3-sneaker');
        return go('result');
      }
      go('result');
    }

    function init() {
      cfgEl = qs('#fitquiz-config'); body = qs('#fitquiz-body');
      if (!cfgEl || !body) return false;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = { results: {} }; }
      body.addEventListener('click', function (e) {
        var t = e.target.closest('button');
        if (!t) return;
        if (t.hasAttribute('data-go')) return go(t.getAttribute('data-go'));
        if (t.hasAttribute('data-answer')) {
          var parts = t.getAttribute('data-answer').split(':');
          if (parts[0] === 'type') fq.answers = {};
          fq.answers[parts[0]] = parts[1];
          fq.overrideKey = null;
          return advance();
        }
        if (t.hasAttribute('data-fq-back')) {
          if (fq.history.length) { fq.step = fq.history.pop(); fq.overrideKey = null; render(); }
          return;
        }
        if (t.hasAttribute('data-alt')) { fq.overrideKey = t.getAttribute('data-alt'); return render(); }
        if (t.hasAttribute('data-fq-retake')) return reset();
        if (t.hasAttribute('data-fq-shop')) {
          var handle = cfg.results[fq.resultKey].handle;
          closeOverlay(qs('#fitquiz-modal'));
          setTimeout(function () { QuickView.open(handle); }, 320);
        }
      });
      return true;
    }
    var ready = false;
    return {
      open: function () {
        if (!ready) ready = init();
        if (!ready) return;
        reset();
        openOverlay(qs('#fitquiz-modal'), qs('#fitquiz-close'));
        render();
      }
    };
  })();
  window.SixFtFitQuiz = FitQuiz;

  /* ---------------------------------------------------------------------
     Delegated clicks (survive cart drawer re-renders)
  --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('#mobile-nav-toggle')) { MobileNav.open(); return; }
    if (t.closest('#mobile-nav-close') || t.id === 'mobile-nav-overlay') { MobileNav.close(); return; }
    var mToggle = t.closest('.mobile-nav-toggle');
    if (mToggle) {
      var item = mToggle.closest('.mobile-nav-item');
      item.classList.toggle('open');
      mToggle.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      return;
    }

    var quizTrigger = t.closest('[data-open-fit-quiz]');
    if (quizTrigger && qs('#fitquiz-modal')) {
      e.preventDefault();
      MobileNav.close();
      FitQuiz.open();
      return;
    }
    if (t.closest('#fitquiz-close') || t.id === 'fitquiz-backdrop') { closeOverlay(qs('#fitquiz-modal')); return; }

    var qv = t.closest('.qv-btn[data-product-handle], .qv-btn-inline[data-product-handle]');
    if (qv) { e.preventDefault(); e.stopPropagation(); QuickView.open(qv.getAttribute('data-product-handle')); return; }
    if (t.closest('#qv-close') || t.id === 'qv-backdrop') { closeOverlay(qs('#qv-modal')); return; }
    if (t.closest('#qv-cta')) { QuickView.add(); return; }

    if (t.closest('#cart-toggle')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('#cart-close') || t.id === 'cart-backdrop') { Cart.close(); return; }

    var qtyBtn = t.closest('.cart-qty-btn');
    if (qtyBtn) {
      var line = qtyBtn.closest('.cart-line-item');
      var qty = parseInt(line.getAttribute('data-quantity'), 10) || 1;
      var next = qtyBtn.getAttribute('data-action') === 'inc' ? qty + 1 : Math.max(1, qty - 1);
      if (next !== qty) Cart.change(qtyBtn.getAttribute('data-key'), next);
      return;
    }
    var removeBtn = t.closest('.cart-remove-btn');
    if (removeBtn) { Cart.change(removeBtn.getAttribute('data-key'), 0); return; }

    var upsell = t.closest('.cart-upsell-add');
    if (upsell) {
      if (upsell.classList.contains('added')) return;
      var upsellVariantId = upsell.getAttribute('data-variant-id');
      if (!upsellVariantId && upsell.hasAttribute('data-product-id')) {
        var upsellSelect = qs('.cart-upsell-size-select[data-product-id="' + upsell.getAttribute('data-product-id') + '"]');
        upsellVariantId = upsellSelect && upsellSelect.value;
      }
      if (!upsellVariantId) return;
      upsell.classList.add('added');
      upsell.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 13 L10 18 L19 7" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      Cart.addVariant(upsellVariantId, 1).catch(function () { Cart.refresh(); });
      return;
    }
    if (t.closest('#cart-upsell-loadmore')) {
      var hidden = qsa('#cart-upsell-list .cart-upsell-item[hidden]');
      hidden.slice(0, 2).forEach(function (el) { el.hidden = false; });
      if (hidden.length <= 2) { var lm = qs('#cart-upsell-loadmore'); lm.disabled = true; lm.textContent = 'No more recommendations'; }
      return;
    }

    var discToggle = t.closest('#cart-discount-toggle');
    if (discToggle) {
      var form = qs('#cart-discount-form');
      var isOpen = form.classList.toggle('is-open');
      discToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      qs('#cart-discount-chevron').style.transform = isOpen ? 'rotate(180deg)' : '';
      if (isOpen) qs('#cart-discount-input').focus();
      return;
    }
    if (t.closest('#cart-discount-apply')) { applyDiscount(); return; }
    if (t.closest('[data-remove-discount]')) { Cart.updateDiscount('').catch(function (err) { toast(err.message); }); return; }

    var estToggle = t.closest('#cart-ship-est-toggle');
    if (estToggle) {
      var ef = qs('#cart-ship-est-form');
      var eo = ef.classList.toggle('is-open');
      estToggle.setAttribute('aria-expanded', eo ? 'true' : 'false');
      qs('#cart-ship-est-chevron').style.transform = eo ? 'rotate(180deg)' : '';
      if (eo) qs('#cart-ship-est-input').focus();
      return;
    }
    if (t.closest('#cart-ship-est-apply')) { runEstimate(); return; }
    if (t.closest('#cart-ship-est-change')) {
      qs('#cart-ship-est-result').classList.remove('is-visible');
      qs('#cart-ship-est-toggle').hidden = false;
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.cart-size-select');
    if (!sel) return;
    var line = sel.closest('.cart-line-item');
    Cart.swapVariant(sel.getAttribute('data-key'), sel.value, parseInt(line.getAttribute('data-quantity'), 10) || 1);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target.id === 'cart-discount-input') { e.preventDefault(); applyDiscount(); }
    if (e.target.id === 'cart-ship-est-input') { e.preventDefault(); runEstimate(); }
  });

  function applyDiscount() {
    var input = qs('#cart-discount-input');
    var code = (input.value || '').trim();
    var err = qs('#cart-discount-error');
    if (!code) return;
    err.classList.remove('is-visible');
    Cart.updateDiscount(code).then(function (res) {
      var codes = (res && res.discount_codes) || [];
      var hit = codes.filter(function (c) { return String(c.code).toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) return;
      var e3 = qs('#cart-discount-error');
      var form = qs('#cart-discount-form');
      if (form) form.classList.add('is-open');
      var inp = qs('#cart-discount-input');
      if (inp) inp.value = code;
      if (e3) { e3.textContent = '"' + code + '" is not a valid code for this cart'; e3.classList.add('is-visible'); }
    }).catch(function (ex) {
      var e2 = qs('#cart-discount-error');
      if (e2) { e2.textContent = ex.message; e2.classList.add('is-visible'); }
    });
  }

  function runEstimate() {
    var input = qs('#cart-ship-est-input');
    var err = qs('#cart-ship-est-error');
    var zip = (input.value || '').trim();
    var country = input.getAttribute('data-country') || 'United States';
    err.classList.remove('is-visible');
    if (country === 'United States' && !/^\d{5}(-\d{4})?$/.test(zip)) {
      err.textContent = 'Enter a valid 5-digit ZIP code';
      err.classList.add('is-visible');
      return;
    }
    var btn = qs('#cart-ship-est-apply');
    btn.disabled = true; btn.textContent = '…';
    estimateShipping(zip, country).then(function (rates) {
      qs('#cart-ship-est-zip-label').textContent = 'Shipping to ' + zip;
      qs('#cart-ship-est-rates').innerHTML = formatRates(rates);
      qs('#cart-ship-est-form').classList.remove('is-open');
      qs('#cart-ship-est-toggle').hidden = true;
      qs('#cart-ship-est-result').classList.add('is-visible');
    }).catch(function (ex) {
      err.textContent = ex.message;
      err.classList.add('is-visible');
    }).then(function () { btn.disabled = false; btn.textContent = 'Estimate'; });
  }

  /* ---------------------------------------------------------------------
     Page-level widgets bound once the DOM is ready
  --------------------------------------------------------------------- */
  function initMegaMenu() {
    var wrap = qs('.nav-shop-wrap');
    var menu = qs('.mega-menu');
    if (!wrap || !menu) return;
    var timer = null;
    var open = function () { clearTimeout(timer); menu.classList.add('js-open'); };
    var close = function () { clearTimeout(timer); timer = setTimeout(function () { menu.classList.remove('js-open'); }, 250); };
    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', close);
    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);
    wrap.addEventListener('focusin', open);
    menu.addEventListener('focusin', open);
    menu.addEventListener('focusout', function (e) { if (!menu.contains(e.relatedTarget) && !wrap.contains(e.relatedTarget)) close(); });
    wrap.addEventListener('focusout', function (e) { if (!menu.contains(e.relatedTarget) && !wrap.contains(e.relatedTarget)) close(); });
  }

  function initFaq() {
    qsa('.faq-item').forEach(function (item) {
      var q = qs('.faq-question', item);
      if (!q || q._sx) return;
      q._sx = true;
      q.addEventListener('click', function () {
        item.classList.toggle('open');
        q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      });
    });
  }

  function initLiftSliders() {
    qsa('.ba-wrap').forEach(function (root) {
      var inside = qs('.ba-inside', root), divider = qs('.ba-divider', root), handle = qs('.ba-handle', root);
      if (!inside || !divider || !handle) return;
      var pos = 50;
      var clamp = function (n) { return Math.max(4, Math.min(96, n)); };
      var set = function (pct) {
        pos = clamp(pct);
        inside.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
        divider.style.left = pos + '%';
        handle.style.left = pos + '%';
        root.setAttribute('aria-valuenow', Math.round(pos));
      };
      var stopIntro = function () {
        root.classList.remove('play-intro');
        inside.style.animation = 'none'; divider.style.animation = 'none'; handle.style.animation = 'none';
      };
      var fromEvent = function (e) { var r = root.getBoundingClientRect(); return ((e.clientX - r.left) / r.width) * 100; };
      var dragging = false;
      root.addEventListener('pointerdown', function (e) { stopIntro(); dragging = true; try { root.setPointerCapture(e.pointerId); } catch (x) {} set(fromEvent(e)); });
      root.addEventListener('pointermove', function (e) { if (dragging) set(fromEvent(e)); });
      var up = function (e) { dragging = false; try { root.releasePointerCapture(e.pointerId); } catch (x) {} };
      root.addEventListener('pointerup', up);
      root.addEventListener('pointercancel', up);
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); stopIntro(); set(pos + (e.key === 'ArrowLeft' ? -5 : 5)); }
      });
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting && !dragging) { root.classList.add('play-intro'); io.unobserve(root); } });
        }, { threshold: 0.4 });
        io.observe(root);
      }
    });
  }

    function initCarousels() {
    qsa('[data-carousel]').forEach(function (wrapEl) {
      if (wrapEl.dataset.carouselBound === 'true') return;
      wrapEl.dataset.carouselBound = 'true';

      var track = qs('.carousel-track', wrapEl), viewport = qs('.carousel-viewport', wrapEl), dotsWrap = qs('.carousel-dots', wrapEl);
      if (!track || !viewport) return;
      var prev = qs('[data-carousel-prev]', wrapEl), next = qs('[data-carousel-next]', wrapEl), pause = qs('[data-carousel-pause]', wrapEl);
      var cards = Array.prototype.slice.call(track.children);
      var index = 0, maxIndex = -1, timer = null;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var playing = !reduced && wrapEl.getAttribute('data-autoplay') !== 'false';
      var PAUSE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M8 6 V18 M16 6 V18" stroke-linecap="round"></path></svg>';
      var PLAY = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M8 5.5 L18.5 12 L8 18.5 Z"></path></svg>';
      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var i = 0; i <= maxIndex; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button'; d.className = 'carousel-dot' + (i === index ? ' active' : '');
            d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            d.addEventListener('click', function () { goTo(i); restart(); });
            dotsWrap.appendChild(d);
          })(i);
        }
      }
      function render() {
        if (!cards.length) return;
        var step = cards[0].getBoundingClientRect().width + 22;
        var visible = Math.max(1, Math.round(viewport.getBoundingClientRect().width / step));
        var newMax = Math.max(0, cards.length - visible);
        if (newMax !== maxIndex) { maxIndex = newMax; index = Math.min(index, maxIndex); buildDots(); }
        track.style.transform = 'translateX(-' + (step * index) + 'px)';
        if (dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('active', i === index); });
        cards.forEach(function (c, i) { c.toggleAttribute('inert', i < index || i >= index + visible); });
      }
      function goTo(i) { var count = maxIndex + 1; index = ((i % count) + count) % count; render(); }
      function start() { clearInterval(timer); if (playing) timer = setInterval(function () { goTo(index + 1); }, 5000); }
      function restart() { if (playing) start(); }
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); restart(); });
            var touchStartX = 0, touchStartY = 0, touchDeltaX = 0, touchIsHorizontal = null;
      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        touchIsHorizontal = null;
        clearInterval(timer);
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        var x = e.touches[0].clientX, y = e.touches[0].clientY;
        touchDeltaX = x - touchStartX;
        var touchDeltaY = y - touchStartY;
        if (touchIsHorizontal === null) touchIsHorizontal = Math.abs(touchDeltaX) > Math.abs(touchDeltaY);
        if (touchIsHorizontal) e.preventDefault();
      }, { passive: false });
      viewport.addEventListener('touchend', function () {
        if (touchIsHorizontal) {
          if (touchDeltaX < -40) goTo(index + 1);
          else if (touchDeltaX > 40) goTo(index - 1);
        }
        restart();
      });
      if (pause) {
        var sync = function () { pause.innerHTML = playing ? PAUSE : PLAY; pause.setAttribute('aria-label', playing ? 'Pause carousel' : 'Play carousel'); };
        sync();
        pause.addEventListener('click', function () { playing = !playing; sync(); if (playing) start(); else clearInterval(timer); });
      }
      wrapEl.addEventListener('focusin', function () { clearInterval(timer); });
      wrapEl.addEventListener('focusout', function () { restart(); });
      window.addEventListener('resize', render);

      /* Lets content that loads in later (Related products fetches its
         cards after page load) tell an already-bound carousel to pick up
         the new cards, without re-attaching the arrow/pause listeners. */
      wrapEl.sixftCarouselRefresh = function () {
        cards = Array.prototype.slice.call(track.children);
        index = 0;
        maxIndex = -1;
        render();
        restart();
      };

      render();
      start();
    });
  }

  /* ---------------------------------------------------------------------
     Sticky header — three modes, set on the Header section's "Header on
     scroll" setting and read here off #site-header's data attribute, so
     the CSS stays inert until JS confirms which mode is live.
       "static"         → do nothing; header scrolls away as before.
       "always-fixed"   → pinned at the top, never hides.
       "hide-on-scroll" → pinned, hides on scroll down, returns on scroll up.
     #sticky-header-group (layout/theme.liquid) wraps the announcement bar
     and the header as ONE unit so both move together; splitting them
     strands the announcement bar behind the fixed header. --header-height
     is kept live because the real height changes with the logo setting,
     the announcement bar and mobile menu wrapping.
  --------------------------------------------------------------------- */
  var stickyHeaderBound = false;
  function initStickyHeader() {
    if (stickyHeaderBound) return;
    var group = document.getElementById('sticky-header-group');
    var siteHeader = document.getElementById('site-header');
    if (!group || !siteHeader) return;
    var behavior = siteHeader.dataset.stickyBehavior || 'static';

    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--header-height', group.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    /* Web fonts landing after first paint reflow the logo and menu text. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderHeight);
    stickyHeaderBound = true;

    if (behavior === 'static') return;
    group.classList.add('is-sticky');
    if (behavior !== 'hide-on-scroll') return;

    group.classList.add('hides-on-scroll');
    var overlay = document.getElementById('mobile-nav-overlay');
    var lastY = window.scrollY;
    var markY = window.scrollY;
    var ticking = false;
    var THRESHOLD = 8; /* px of accumulated scroll before reacting — ignores rubber-banding */

    var update = function () {
      var y = window.scrollY;
      var navOpen = overlay && overlay.classList.contains('open');
      if (navOpen || y <= group.offsetHeight) {
        /* Always visible near the top, and never hide it out from under
           the mobile menu, which is anchored to it. */
        group.classList.remove('is-header-hidden');
        markY = y;
      } else if (y > lastY && y - markY > THRESHOLD) {
        group.classList.add('is-header-hidden');
        markY = y;
      } else if (y < lastY && markY - y > THRESHOLD) {
        group.classList.remove('is-header-hidden');
        markY = y;
      }
      lastY = y;
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ---------------------------------------------------------------------
     Scroll-to-top button. Visible only once the footer (.site-footer)
     scrolls into view, via IntersectionObserver — with a fixed
     scroll-distance fallback for the rare browser without it. Also
     shifts itself up while the PDP's sticky add-to-cart bar is showing
     so the two never overlap — that bar is .pdp-sticky-bar[data-pdp-sticky]
     and it shows with .show.
  --------------------------------------------------------------------- */
  var scrollTopBound = false;
  function initScrollTop() {
    if (scrollTopBound) return;
    var btn = document.getElementById('scroll-to-top-btn');
    if (!btn) return;
    scrollTopBound = true;
    var footer = document.querySelector('.site-footer');
    var footerVisible = false;
    var ticking = false;

    var update = function () {
      btn.classList.toggle('is-visible', footerVisible);
      var bar = document.querySelector('[data-pdp-sticky]');
      var pushed = !!(bar && bar.classList.contains('show'));
      btn.classList.toggle('is-pushed-up', pushed);
      if (pushed) {
        document.documentElement.style.setProperty('--pdp-sticky-bar-height', (bar.offsetHeight + 20) + 'px');
      }
      ticking = false;
    };

    if (footer && 'IntersectionObserver' in window) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    } else {
      /* No footer on this template, or no IntersectionObserver support —
         fall back to a fixed scroll distance so the button still works. */
      var fallbackThreshold = 800;
      window.addEventListener('scroll', function () {
        footerVisible = window.scrollY > fallbackThreshold;
      }, { passive: true });
      footerVisible = window.scrollY > fallbackThreshold;
    }
    update();

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    btn.addEventListener('click', function () {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------------------------------------------------------------------
     Hero slideshow. .hero--multi is only emitted when the hero has more
     than one Slide block, so a single-slide hero never gets any of this.
  --------------------------------------------------------------------- */
  function initHeroSlideshow() {
    qsa('.hero--multi').forEach(function (hero) {
      if (hero.dataset.heroBound === 'true') return;
      var slides = qsa('.hero__slide', hero);
      if (slides.length < 2) return;
      hero.dataset.heroBound = 'true';

      var dots = qsa('.hero__dot', hero);
      var prevBtn = qs('[data-hero-prev]', hero);
      var nextBtn = qs('[data-hero-next]', hero);
      var index = 0;
      var autoplay = hero.dataset.autoplay === 'true';
      var speed = (parseInt(hero.dataset.autoplaySpeed, 10) || 6) * 1000;
      var timer = null;

      var show = function (i) {
        index = ((i % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        dots.forEach(function (d, n) { d.classList.toggle('active', n === index); });
      };
      var next = function () { show(index + 1); };
      var prev = function () { show(index - 1); };
      var stopAutoplay = function () { if (timer) { clearInterval(timer); timer = null; } };
      var startAutoplay = function () { if (!autoplay) return; stopAutoplay(); timer = setInterval(next, speed); };
      var restart = function () { stopAutoplay(); startAutoplay(); };

      dots.forEach(function (dot, n) { dot.addEventListener('click', function () { show(n); restart(); }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
      hero.addEventListener('mouseenter', stopAutoplay);
      hero.addEventListener('mouseleave', startAutoplay);

      var startX = null, startY = null, dragging = false;
      hero.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; dragging = true; }, { passive: true });
      hero.addEventListener('pointermove', function (e) {
        if (!dragging || startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        /* Only claim the gesture once it is clearly horizontal, so a
           normal vertical scroll is never hijacked. */
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) e.preventDefault();
      }, { passive: false });
      var endSwipe = function (e) {
        if (!dragging || startX === null) { dragging = false; return; }
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 40) { if (dx < 0) { next(); } else { prev(); } restart(); }
        dragging = false; startX = null; startY = null;
      };
      hero.addEventListener('pointerup', endSwipe);
      hero.addEventListener('pointercancel', function () { dragging = false; startX = null; });

      show(0);
      startAutoplay();
    });
  }

  function initAll() {
    initMegaMenu();
    initFaq();
    initLiftSliders();
    initCarousels();
    initStickyHeader();
    initScrollTop();
    initHeroSlideshow();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Theme editor: re-bind widgets when a section is added or reloaded */
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
